//WE.Flow.Html.Contracts.Manifests.ImpersonatedUser

export class ImpersonatedUser {
    personId: string = "";
    name: string = "";
}
